export enum FavoriteEndPoint {
  GetShortList = 'favorites/short/get/',
  GetList = 'favorites/get/',
  Add = 'favorite/add/',
  Delete = 'favorite/del/',
}
